export const RentWagonColor = {
  NOT_RENTED: '#e1e8ed',
  RENTED: '#0f9960',
  PAUSED: '#ffd966',
  IN_REPAIR: '#ff6e4a',
};
